import AitiProductVariantGroupOption from './group/option.mjs';

/**
 * @class
 */
var AitiProductVariantGroup = function(data) {

    let _this = this;

    this._data = data;

    /** @var {Object.<string, AitiProductVariantGroupOption>} */
    this._options = {};

    for (let i in this._data['options']) {
        if (this._data['options'].hasOwnProperty(i)) {
            this._options[this._data['options'][i]['id']] = new AitiProductVariantGroupOption(this, this._data['options'][i]);
        }
    }

    this.getId = function() {
        return this._data['id'];
    };

    this.getItemId = function() {
        return this._data['itemId'];
    };

    this.isCurrent = function() {
        return this._data['current'];
    };

    this.setCurrent = function(current) {
        this._data['current'] = current;
        return this;
    };

    this.getOptions = function() {
        return this._options;
    };

    /** @returns {AitiProductVariantGroupOption} */
    this.getOption = function(id) {
        return this.getOptions()[id];
    };
};

export default AitiProductVariantGroup;
